module.exports = __webpack_public_path__ + "img/ivory-coast.8c48118b.svg";